// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledNextButtonContainer = styled(
	({ withoutBackButton, ...props }) => <Block {...props} />
)`
	flex: ${({ withoutBackButton }) =>
		withoutBackButton ? "0 1 60%" : "1 1 60%"};
`;

// #####################################################
